import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import type { Location } from '../data/locations';
import { SERVICES } from '../data/locations';
type LocationCardProps = {
  location: Location;
  index?: number;
};
export function LocationCard({
  location,
  index = 0
}: LocationCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.35,
    delay: Math.min(index, 5) * 0.05,
    ease: 'easeOut'
  }} className="group flex flex-col overflow-hidden rounded-2xl border border-white/5 bg-ink-850/80 transition-colors duration-300 hover:border-lotus-500/40" data-id="element-53" data-mp="2txzuqognio2c">
      <Link to={`/locations/${location.slug}`} className="relative block overflow-hidden" data-id="element-54" data-mp="38s4nd0b9doas">
        <img src={location.image} alt={`${location.name} treatment room`} className="h-52 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" data-id="element-55" data-mp="19jfzmfgsm4vl" />
        <span className="absolute inset-0 bg-gradient-to-t from-ink-850 via-black/20 to-transparent" data-id="element-56" data-mp="3m8ssxkk9dav7" />
        <span className="absolute bottom-4 left-5 text-[11px] font-medium uppercase tracking-[0.28em] text-lotus-400" data-id="element-57" data-mp="3h9oikqlll73a">
          {location.suburb}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-6" data-id="element-58" data-mp="dthggoitzhwm">
        <h3 className="font-display text-2xl font-light tracking-wide text-white" data-id="element-59" data-mp="ds6hd20byybu">
          {location.name}
        </h3>

        <ul className="mt-4 space-y-2.5 text-sm font-light text-neutral-400" data-id="element-60" data-mp="8sbo4rt31wnm">
          <li className="flex gap-2.5" data-id="element-61" data-mp="3tqmqp23h6xl">
            <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-lotus-500/60" aria-hidden="true" data-id="element-62" data-mp="3vz4bac4ovmlm" />
            {location.address}
          </li>
          <li className="flex gap-2.5" data-id="element-63" data-mp="2omlnk8g4rehs">
            <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-lotus-500/60" aria-hidden="true" data-id="element-64" data-mp="2ojg356ig50se" />
            <a href={`tel:${location.phone.replace(/\s/g, '')}`} className="hover:text-lotus-500" data-id="element-65" data-mp="2km1qt5zgycw6">
              {location.phone}
            </a>
          </li>
          <li className="flex gap-2.5" data-id="element-66" data-mp="2qxuymw19fpz8">
            <ClockIcon className="mt-0.5 h-4 w-4 shrink-0 text-lotus-500/60" aria-hidden="true" data-id="element-67" data-mp="2c3q42en3efo5" />
            {location.hours}
          </li>
        </ul>

        <ul className="mt-5 flex flex-wrap gap-2" data-id="element-68" data-mp="2h44c3wop1pm6">
          {SERVICES.map(service => <li key={service.duration} className="rounded-full border border-lotus-500/20 px-3 py-1 text-[11px] font-medium tracking-wide text-lotus-400" data-id="element-69" data-mp="238jtz3gshbft">
              {service.duration} · {service.price}
            </li>)}
        </ul>

        <Link to={`/locations/${location.slug}`} className="mt-auto inline-flex items-center gap-2 pt-6 text-[11px] font-semibold uppercase tracking-[0.24em] text-lotus-500 transition-colors hover:text-lotus-400" data-id="element-70" data-mp="1ybtf2jgq0lvz">
          View Studio
          <ArrowRightIcon className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-71" data-mp="15oa944izehtk" />
        </Link>
      </div>
    </motion.article>;
}